<template lang="pug">
    .about-contentbox
        .container
            .row
                .col-md-12
                    | {{content}}
</template>

<script>
export default {
    props: ["content"]
}
</script>



// WEBPACK FOOTER //
// src/components/atoms/PmContentBox.vue